import React, { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./finishedScreen.css";
import { useTranslation } from "react-i18next";

const NotCompletionScreen = ({ lesson, onRepeat }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const handleNextLesson = () => {
    const currentId = parseInt(id);
    const nextId = currentId + 1;
    navigate(`/lesson/${nextId}`);
    window.location.reload();
  };

  const handleRepeatLesson = () => {
    window.location.reload();
  };

  return (
    <>
      <div className="success-card">
      <div className="success-top">
        <div className="trophy-wrap">
          <div className="sparkles">
            <div className="sparkle"></div>
            <div className="sparkle"></div>
            <div className="sparkle"></div>
            <div className="sparkle"></div>
          </div>
          <div className="strong-bg">💪</div>
        </div>

        <div className="not-success-label">{t("Almost there!")}</div>
        </div>

        <h1 className="success-title">
         {t("Don't be sad")} —<br />
          <span>{t("Every attempt")}</span> {t("is a step forward")}!<br />
        </h1>
        <p className="success-subtitle">
          {t("This time the lesson")} <span>«{lesson?.video?.name || 'Lesson'}»</span> {t("was not completed — but that's okay. Mistakes are part of learning. Repeat the lesson or move on: your choice!")}
        </p>

        <div className="btn-row">
          <button className="btn-secondary" onClick={handleRepeatLesson}>
           {t("Repeat Lesson")}
          </button>
          <button className="btn-primary" onClick={handleNextLesson}>
            {t("Next Lesson")} <span className="arrow">→</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default NotCompletionScreen;
